<div class="notification-modal-shell">
  <ion-row
    class="notification-container modal-drag-handle"
    appDraggableModal
    role="button"
    tabindex="0"
    aria-label="Move notification dialog"
    title="Drag to move dialog"
  >
    <span class="modal-drag-grip" aria-hidden="true"></span>
    <ion-title class="ion-float-left">
      {{ status.notification.saved ? notification?.notificationTypeLabel : 'Notification' }}
    </ion-title>
    <img
      class="notification-icon-image"
      [src]="status.notification.saved ? notification?.notificationIconImage : '/assets/icon-notify-counter.png'"
      alt=""
    />
  </ion-row>

  <ng-container *ngIf="status.notification.saved == false; else sendNotification">
    <form *ngIf="createNotificationForm" [formGroup]="createNotificationForm" class="notification-form">
      <ng-container *ngIf="notificationTypesLoading && !notificationTypes.length; else notificationTypesState">
        <div class="notification-loading">
          <ion-spinner name="crescent"></ion-spinner>
          <span>Loading notification options...</span>
        </div>
      </ng-container>

      <ng-template #notificationTypesState>
        <div *ngIf="notificationTypesError; else notificationOptions" class="notification-load-error" role="alert">
          <span>{{ notificationTypesError }}</span>
        </div>
      </ng-template>

      <ng-template #notificationOptions>
        <ion-list class="notification-options" lines="none" inset>
          <ion-radio-group class="followup-form-choice-grid" formControlName="notificationTypeId">
            <ion-radio
              *ngFor="let notificationType of notificationTypes"
              class="followup-form-choice notification-choice"
              [value]="notificationType.notificationTypeId"
              labelPlacement="end"
              alignment="start"
              justify="start"
            >
              {{ notificationType.notificationTypeLabel }}
            </ion-radio>
          </ion-radio-group>
        </ion-list>
      </ng-template>

      <ion-textarea
        [autoGrow]="true"
        class="notification-textarea"
        formControlName="notificationMessage"
        placeholder="Leave Your Notes Here"
        spellcheck="true"
        autocorrect="on"
        autocapitalize="sentences"
      ></ion-textarea>
      <ion-row>
        <div class="send-container">
          <button class="secondary button" type="button" (click)="dismiss()">Cancel</button>
          <button
            [disabled]="createNotificationForm.invalid || notificationTypesLoading || !!notificationTypesError || notificationRecipientsLoading"
            class="primary button"
            type="button"
            (click)="saveNotification()"
          >
            {{ notificationRecipientsLoading ? 'Checking...' : 'Save' }}
          </button>
        </div>
      </ion-row>
    </form>
  </ng-container>

  <ng-template #sendNotification>
    <ion-row>
      <div class="review-container">
        <form *ngIf="createNotificationForm" [formGroup]="createNotificationForm">
          <ion-list class="review-notification-list" lines="none" inset>
            <ion-item class="notification-review-item">
              <span class="label">Patient:&nbsp;</span>
              {{ notification.notificationPatientFirstName }}
              {{ notification.notificationPatientLastName }}
            </ion-item>
            <ion-item class="notification-review-item">
              <span class="label">Patient #:&nbsp;</span>
              {{ notification.notificationPatientMedicalRecordNumber }}
            </ion-item>
            <ion-item class="notification-review-item">
              <span class="label">Facility:&nbsp;</span>
              {{ notification.notificationOperationName }}
            </ion-item>
            <ion-item class="notification-review-item ion-text-wrap">
              <ion-label class="label ion-text-wrap"
                ><span class="label">Notify:&nbsp;</span>
                <ng-container *ngIf="hasNotificationRecipients; else noRecipients">
                  <span *ngFor="let notificationRecipient of notificationRecipients; let idx = index">
                    {{ notificationRecipient.notificationRecipientEmail
                    }}{{ idx + 1 == notificationRecipients.length ? '' : ', ' }}
                  </span>
                </ng-container>
                <ng-template #noRecipients>
                  Woops! No recipients have been set. Click
                  <a [routerLink]="['/operations', notification.notificationOperationId]">here</a>
                  to go set some recipients!
                </ng-template>
              </ion-label>
            </ion-item>
            <ion-item class="notification-review-item">
              <span class="label">Date of Notification:&nbsp;</span> {{ todaysDate }}
            </ion-item>
            <ion-item class="notification-review-item">
              <span class="label">Message:&nbsp;</span>
            </ion-item>
            <ion-item class="notification-review-item-message">
              <ion-textarea
                [autoGrow]="true"
                class="notification-review-textarea"
                formControlName="notificationMessage"
                spellcheck="true"
                autocorrect="on"
                autocapitalize="sentences"
              ></ion-textarea>
            </ion-item>
          </ion-list>
        </form>
      </div>
    </ion-row>
    <ion-row>
      <div class="send-container">
        <button class="ion-float-left secondary button edit" type="button" [disabled]="isSending" (click)="editNotification()">Back</button>
        <button
          class="ion-float-right primary button send"
          [disabled]="isSending || notificationRecipientsLoading || createNotificationForm.invalid || !hasNotificationRecipients"
          type="button"
          (click)="sendTheNotification()"
        >
          Send
        </button>
      </div>
    </ion-row>
  </ng-template>
</div>
